import { render, staticRenderFns } from "./WashbasinDashboard.vue?vue&type=template&id=07b36b64&"
import script from "./WashbasinDashboard.vue?vue&type=script&lang=js&"
export * from "./WashbasinDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports